import { Kampos, effects, noise, utilities } from 'kampos';
import { getEffectReveal, lerp, sineInOut } from '../utilities/motion';
export default async function create(target, options) {
  const {
    frequency = 3,
    intensity = 0.1,
    direction = 'x'
  } = options.namedEffect;
  let {
    autoplay = true,
    speed = 1
  } = options.namedEffect;
  const resolution = utilities.resolution({
    width: target.width,
    height: target.height
  });
  const initialMouse = {
    x: 0.5,
    y: 0.5
  };
  const mouse = utilities.mouse({
    initial: initialMouse
  });
  const slitScan = effects.slitScan({
    noise: noise.simplex2d,
    frequency,
    intensity,
    direction,
    offsetInput: `u_mouse.${direction}`
  });
  const instance = new Kampos({
    effects: [resolution, mouse, slitScan],
    target
  });
  let lastMouse = initialMouse;
  let lastScroll = 0;
  let _revealEffect;
  return {
    instance,
    play(_temp) {
      let {
        reveal,
        beforeDraw
      } = _temp === void 0 ? {} : _temp;
      if (reveal) {
        _revealEffect = getEffectReveal(progress => {
          this.setters.intensity(lerp(0, intensity, sineInOut(progress)));
        });
      }
      this.instance.play(beforeDraw);
    },
    beforeDraw(t) {
      if (autoplay) {
        slitScan.time = t * speed;
      }
      if (_revealEffect) {
        const done = _revealEffect(t);
        if (done) {
          _revealEffect = undefined;
        }
      }
    },
    setters: {
      speed(f) {
        speed = f;
      },
      intensity(i) {
        slitScan.intensity = i;
      },
      frequency(f) {
        slitScan.frequency = f;
      },
      mouse(p) {
        if (p.active !== false) {
          lastMouse = p;
          mouse.position = {
            x: p.x + lastScroll,
            y: p.y + lastScroll
          };
        }
      },
      scroll(p) {
        lastScroll = p;
        mouse.position = {
          x: lastMouse.x + p,
          y: lastMouse.y + p
        };
      },
      autoplay(b) {
        autoplay = b;
      }
    },
    resize(w, h) {
      resolution.resolution = {
        width: w,
        height: h
      };
      instance.setSource({
        width: w,
        height: h
      });
    }
  };
}
//# sourceMappingURL=SlitScan.js.map